import axios from "axios"
import moment from "moment"
import authenticate from "./authenticate"
import errorHandling from "./errorHandling"
import { Core as YubinBangoCore } from "yubinbango-core2"
import "moment/locale/ja"

export default {
	async searchOrderedProducts(searchWord) {
		const headers = authenticate.setHeader()
		return axios
			.get("/erp/v1/parts_list/search_ordered_products.json", {
				headers,
				params: { search_word: searchWord },
			})
			.catch((err) => {
				console.log(err)
				errorHandling.errorResponse(err)
			})
	},
	async searchComponents(searchWord, searchNumber) {
		const headers = authenticate.setHeader()
		return axios
			.get("/erp/v1/parts_list/search_components.json", {
				headers,
				params: { search_word: searchWord, search_number: searchNumber },
			})
			.catch((err) => {
				console.log(err)
				errorHandling.errorResponse(err)
			})
	},
	yubinbango(code) {
		if (code) {
			let postalCode = code.replace(/-/g, "")
			let address_info = {
				prefecture: "",
				city: "",
				street: "",
			}
			new YubinBangoCore(postalCode, (addr) => {
				address_info["prefecture"] = addr.region // 都道府県
				address_info["city"] = addr.locality // 市区町村
				address_info["street"] = addr.street // 町域
			})
			return address_info
		} else {
			return null
		}
	},
	returnMatterInfo(matter) {
		if (matter) {
			return (
				"【" +
				matter.situation +
				"】" +
				matter.name +
				"\n見積番号：" +
				matter.quotation_number +
				"-" +
				matter.quotation_sub_number +
				"\n受注番号：" +
				(matter.order_number ? matter.order_number : "未受注")
			)
		} else {
			return ""
		}
	},
	zeroPadding(NUM, LEN) {
		return (Array(LEN).join("0") + NUM).slice(-LEN)
	},
	returnMatterInfoWithOrderNumber(matter) {
		if (matter) {
			let returnWord =
				"[" +
				matter.situation +
				"]" +
				matter.name +
				"\n見積番号:" +
				matter.quotation_number +
				"-" +
				matter.quotation_sub_number +
				(matter.order_number ? "\n受注番号:" + matter.order_number : "")
			if (matter.ordered_products) {
				matter.ordered_products.forEach((op, i) => {
					returnWord += "\n製番" + (i + 1) + ":" + op.product_number
				})
			}
			return returnWord
		} else {
			return ""
		}
	},
	productNameWithSubName(orderedProduct) {
		return (
			orderedProduct.product.name + (orderedProduct.sub_name ? " " + orderedProduct.sub_name : "")
		)
	},
	returnOrderedProductInfo(orderedProduct) {
		if (orderedProduct) {
			return "製番：" + orderedProduct.product_number + " 数量:" + orderedProduct.quantity
		} else {
			return ""
		}
	},
	returnOrderIndividualInfo(orderIndividual) {
		if (orderIndividual) {
			return String(orderIndividual.sub_number).padStart(3, "0")
		} else {
			return ""
		}
	},
	productNameWithProductNumber(orderIndividualInfo, withBreak = false) {
		if (orderIndividualInfo.ordered_product) {
			const productName = orderIndividualInfo.ordered_product.product.name
			const productNumber = orderIndividualInfo.ordered_product.product_number
			return `${productName} ${
				withBreak ? "\n" : ""
			}製造番号:${productNumber}-${this.returnOrderIndividualInfo(orderIndividualInfo)}`
		} else if (orderIndividualInfo.matter_product) {
			const productName = orderIndividualInfo.matter_product.product.name
			return `${productName} ${
				withBreak ? "\n" : ""
			}未受注製品 枝番号: ${this.returnOrderIndividualInfo(orderIndividualInfo)}`
		} else {
			return "エラー"
		}
	},
	productNumberByOrderIndividualInfo(orderIndividualInfo) {
		if (orderIndividualInfo.ordered_product) {
			const productNumber = orderIndividualInfo.ordered_product.product_number
			return `${productNumber}-${this.returnOrderIndividualInfo(orderIndividualInfo)}`
		} else if (orderIndividualInfo.matter_product) {
			return `未受注製品 枝番号: ${this.returnOrderIndividualInfo(orderIndividualInfo)}`
		} else {
			return "エラー"
		}
	},
	checkRequirementFix(requirement, fixes, type) {
		let baseValue = requirement[type]
		this.sortCreatedAt(fixes).forEach((fix) => {
			if (fix[type]) {
				baseValue = fix[type]
			}
		})
		return baseValue
	},
	checkAnswerFix(answer, fixes, type) {
		let baseValue = answer[type]
		this.sortCreatedAt(fixes).forEach((fix) => {
			if (fix[type]) {
				baseValue = fix[type]
			}
		})
		return baseValue
	},
	returnValueWithFix(value) {
		if (value.requirement_value_fixes.length > 0) {
			let fixes = this.sortCreatedAt(value.requirement_value_fixes)
			return fixes.pop()
		} else {
			return value
		}
	},
	returnAnswerValueWithFix(value) {
		if (value.answer_value_fixes.length > 0) {
			let fixes = this.sortCreatedAt(value.answer_value_fixes)
			return fixes.pop()
		} else {
			return value
		}
	},
	returnValueValue(value) {
		let data = ""
		if (value.value_text) {
			data = value.value_text
		} else if (value.value_date) {
			data = moment(value.value_date).format("YYYY/MM/DD")
		} else if (value.value_boolean || value.value_boolean == false) {
			data = this.returnMaruBatsu(value.value_boolean)
		} else if (value.value_integer) {
			data = value.value_integer
		} else if (value.value_float) {
			data = value.value_float
		} else if (value.value_url) {
			data = value.value_url
		} else if (value.value_feature) {
			data = value.value_feature
		} else if (value.value_option) {
			data = value.value_option
		} else if (value.value_string) {
			data = value.value_string
		} else if (value.target_data) {
			data = value.target_data?.name
		}
		return data
	},
	returnValue(valueValue, dataType) {
		let data = ""
		if (dataType == "text") {
			data = valueValue
		} else if (dataType == "date") {
			data = moment(valueValue).format("YYYY/MM/DD")
		} else if (dataType == "boolean") {
			data = this.returnMaruBatsu(valueValue)
		} else if (dataType == "integer") {
			data = valueValue
		} else if (dataType == "float") {
			data = valueValue
		} else if (dataType == "url") {
			data = valueValue
		} else if (dataType == "feature") {
			data = valueValue
		} else if (dataType == "option") {
			data = valueValue
		} else if (dataType == "string") {
			data = valueValue
		} else if (dataType == "target") {
			data = valueValue
		}
		return data
	},
	returnMaruBatsu(bool) {
		if (bool == "true") {
			return "○"
		} else if (bool == "false") {
			return "×"
		} else if (bool == true) {
			return "○"
		} else if (bool == false) {
			return "×"
		} else if (bool == null) {
			return "×"
		}
	},
	value(column, value) {
		if (!column) return null
		if (column.data_type == "boolean") {
			return this.returnMaruBatsu(value)
		} else if (column.data_type == "date") {
			if (!value) return null
			return moment(value).format("YYYY/MM/DD")
		} else if (column.data_type == "time") {
			if (!value) return null
			return moment(value).format("HH:mm")
		} else if (column.data_type == "datetime") {
			if (!value) return null
			return moment(value).format("YYYY/MM/DD HH:mm")
		} else if (column.data_type == "target") {
			return value?.name
		} else if (column.data_type == "synchronization") {
			let name = this.digValue(column, value?.model)
			if (name == null) {
				return ""
			} else if (value?.synchronized_datum) {
				return name + " (下書きデータ)"
			} else {
				return name
			}
		} else {
			return value
		}
	},
	// メタデータの値をカラム名を指定して取得する
	getMetaValueByColumnName(
		data,
		columnName,
		metaValueName = "meta_values",
		metaColumnName = "meta_column"
	) {
		if (!data[metaValueName]) return null
		const metaValue = data[metaValueName].find((v) => v[metaColumnName].name == columnName)
		return this.value(metaValue[metaColumnName], metaValue?.value)
	},
	// メタデータの値をカラム名を指定して取得する メタカラムの配列を渡す必要がある
	getMetaValueByColumnNameWithMetaKeys(
		data,
		columnName,
		metaKeys,
		metaValueName = "meta_values",
		metaColumnId = "meta_column_id"
	) {
		const metaColumn = metaKeys.find((v) => v.name == columnName)
		if (!data[metaValueName] || !metaColumn) return null
		const metaValue = data[metaValueName].find((v) => v[metaColumnId] == metaColumn.id)
		if (!metaValue) return null
		return this.value(metaColumn, metaValue?.value)
	},
	digValue(column, item) {
		const main = column.data_synchronization?.index_columns?.find((c) => c.main_column)
		if (!main || item == null || item == undefined) return null
		const value_array = main.id.split(".")
		let value = item
		value_array.some((key) => {
			value = value[key]
			if (value == null || value == undefined) {
				return true
			}
		})
		if (value == null || value == undefined) return null
		switch (column.data_type) {
			case "date":
				return moment(value).format("YYYY/MM/DD")
			case "datetime":
				return moment(value).format("YYYY/MM/DD HH:mm")
			case "time":
				return moment(value).format("HH:mm")
			default:
				return value
		}
	},

	matterProductByRequirement(requirement) {
		if (!requirement.matter_product || !requirement.matter_product.product) return ""
		return `${requirement.matter_product.product.name} 数量：${requirement.matter_product.quantity}`
	},
	orderedProductByRequirement(requirement) {
		if (!requirement.ordered_product || !requirement.ordered_product.product) return ""
		return `製番：${requirement.ordered_product.product_number}\n${requirement.ordered_product.product.name} 数量：${requirement.ordered_product.quantity}`
	},
	orderIndividualInfoByRequirement(requirement) {
		if (
			requirement.ordered_product &&
			requirement.ordered_product.product &&
			requirement.order_individual_info
		) {
			return `製番：${
				requirement.ordered_product.product_number
			}-${requirement.order_individual_info.sub_number.toString().padStart(3, "0")}\n${
				requirement.ordered_product.product.name
			}\n数量：${requirement.order_individual_info.quantity}`
		} else if (
			requirement.matter_product &&
			requirement.matter_product.product &&
			requirement.order_individual_info
		) {
			return `枝番号：${requirement.order_individual_info.sub_number
				.toString()
				.padStart(3, "0")}\n${requirement.matter_product.product.name}\n数量：${
				requirement.order_individual_info.quantity
			}`
		} else {
			return ""
		}
	},
	sortCreatedAt(objectArry) {
		// 昇順
		if (objectArry) {
			let sorted = objectArry.slice().sort(function (a, b) {
				return a.created_at < b.created_at ? -1 : 1
			})
			return sorted
		} else {
			return []
		}
	},
	sortCreatedAtDESC(objectArry) {
		// 降順
		if (objectArry) {
			let sorted = objectArry.slice().sort(function (a, b) {
				return a.created_at > b.created_at ? -1 : 1
			})
			return sorted
		} else {
			return []
		}
	},
	sortDesc(Array, columnName) {
		let sorted = Array.slice().sort((a, b) => {
			return a[columnName] < b[columnName] ? -1 : 1
		})
		return sorted
	},
	sortAsc(Array, columnName) {
		let sorted = Array.slice().sort((a, b) => {
			return a[columnName] < b[columnName] ? 1 : -1
		})
		return sorted
	},
	tranceMoment(date) {
		return moment(date).format("YYYY/MM/DD")
	},
	formatDate(date) {
		if (!date) return ""
		return moment(date).format("YYYY/MM/DD")
	},
	formatDateWithDay(date) {
		if (!date) return ""
		return moment(date).format("YYYY/MM/DD(dd)")
	},
	formatDateTime(datetime) {
		if (!datetime) return ""
		return moment(datetime).format("YYYY/MM/DD HH:mm")
	},
	formatDateTimeWithDay(datetime) {
		if (!datetime) return ""
		return moment(datetime).format("YYYY/MM/DD(dd) HH:mm")
	},
	formatTime(time) {
		if (!time) return ""
		return moment(time).format("HH:mm")
	},
	formatDateWithNullableTime(data, dateKey, timeKey, withBreak = false) {
		moment.locale("ja")
		if (!data || !data[dateKey]) {
			return ""
		} else if (data[timeKey]) {
			return (
				this.formatDateWithDay(data[dateKey]) +
				`${withBreak ? "\n" : "　"}` +
				this.formatTime(data[timeKey])
			)
		} else {
			return this.formatDateWithDay(data[dateKey]) + `${withBreak ? "\n" : "　"}` + "--:--"
		}
	},
	formatLocalDate(date) {
		if (!date) return ""
		return moment(date).format("YYYY年MM月DD日")
	},
	formatLocalDateWithDay(date) {
		if (!date) return ""
		return moment(date).format("YYYY年MM月DD日(dd)")
	},
	formatLocalDateTime(datetime) {
		if (!datetime) return ""
		return moment(datetime).format("YYYY年MM月DD日 HH時mm分")
	},
	formatLocalDateTimeWithDay(datetime) {
		if (!datetime) return ""
		return moment(datetime).format("YYYY年MM月DD日(dd) HH時mm分")
	},
	formatLocalTime(time) {
		if (!time) return ""
		return moment(time).format("HH時mm分")
	},
	formatLocalDateWithNullableTime(data, dateKey, timeKey) {
		moment.locale("ja")
		if (!data || !data[dateKey]) {
			return ""
		} else if (data[timeKey]) {
			return this.formatLocalDateWithDay(data[dateKey]) + " " + this.formatLocalTime(data[timeKey])
		} else {
			return this.formatLocalDateWithDay(data[dateKey]) + " --:--"
		}
	},

	formatDateTimeWithPlan(data, dateKey, plannedDateKey, timeKey, plannedTimeKey) {
		if (!data || (!data[dateKey] && !data[plannedDateKey])) return ""
		if (data[dateKey]) {
			return this.formatDateWithNullableTime(data, dateKey, timeKey)
		} else if (data[plannedDateKey]) {
			return this.formatDateWithNullableTime(data, plannedDateKey, plannedTimeKey) + " (予定)"
		} else {
			return ""
		}
	},
	formatDateWithPlan(data, dateKey, plannedDateKey) {
		if (!data || (!data[dateKey] && !data[plannedDateKey])) return ""
		if (data[dateKey]) {
			return this.formatDate(data, dateKey)
		} else if (data[plannedDateKey]) {
			return this.formatDate(data, plannedDateKey) + " (予定)"
		} else {
			return ""
		}
	},
	returnUserName(user) {
		return user.last_name + " " + user.first_name
	},
	truncate(str, len) {
		return str.length <= len ? str : str.substr(0, len) + "..."
	},
	setConfirmWord(selectedType) {
		if (selectedType.confirmation_flag) {
			return "確認申請"
		} else if (selectedType.approval_flag) {
			return "承認申請"
		} else {
			return "依頼確定"
		}
	},
	setAnswerConfirmWord(answerTemplate) {
		console.log(answerTemplate)
		if (answerTemplate.need_check_flag) {
			return "確認申請"
		} else if (answerTemplate.need_approval_flag) {
			return "承認申請"
		} else {
			return "回答送信"
		}
	},
	isPresence(value) {
		return value !== null && value !== ""
	},
	isEmptyObject(obj) {
		return !Object.keys(obj).length
	},

	// ここから画面レイアウト用
	names(num = 0) {
		const names = [
			"川上 さやか",
			"伊藤 たかし",
			"木下 めぐみ",
			"高橋 健太郎",
			"山口 みゆき",
			"中島 芳子",
			"渡辺 勇人",
			"石井 美智子",
			"小林 直樹",
			"石田 かおり",
			"佐藤 大翔",
			"鈴木 蓮",
			"高陽 翔",
			"田中 陽菜",
			"山本 結菜",
			"中村 葵",
			"小林 颯太",
			"加藤 心愛",
			"伊藤 凛",
			"山田 大和",
			"佐々木 樹",
			"山口 蒼空",
			"鈴木 凜",
			"田村 結愛",
			"斎藤 結衣",
			"渡辺 陸",
			"長谷川 心結",
			"小川 翔太",
			"佐野 陽向",
			"田辺 美羽",
			"安藤 葉月",
			"岡田 琴音",
			"森田 真央",
			"本田 愛梨",
			"菅原 葵愛",
			"藤田 莉子",
			"杉山 凛音",
			"野村 詩織",
			"高橋 陽葵",
			"松本 美咲",
			"山口 美桜",
		]
		if (num == 0) {
			return names
		} else if (num == 1) {
			return names[Math.floor(Math.random() * names.length)]
		} else {
			let returnNames = []
			for (let i = 0; i < num; i++) {
				returnNames.push(names[Math.floor(Math.random() * names.length)])
			}
			return returnNames
		}
	},
	getData(model, json_data = {}) {
		const params = { model, json_data }
		const url = `/erp/v1/tests`
		axios
			.get(url, { params })
			.then((res) => {
				return res.data
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	isImageFile(file) {
		return file.file_content_type == "image/jpeg" || file.file_content_type == "image/png"
	},
}
